module.exports = __webpack_public_path__ + "img/1F1E6-1F1E8.4f88f8e3.svg";